import styled from 'styled-components';
import { Media, HeaderSizes } from 'enums';
import { ZIndex } from 'config';

export const HeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  min-height: ${HeaderSizes.mobile.height};
  max-height: ${HeaderSizes.mobile.height};
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.white};
  position: sticky;
  top: 0;
  z-index: ${ZIndex.Header};

  @media ${Media.tablet} {
    padding: 8px 40px;
  }

  @media ${Media.notebook} {
    padding: 18px 80px;
    min-height: ${HeaderSizes.notebook.height};
    max-height: ${HeaderSizes.notebook.height};
  }

  @media ${Media.desktop} {
    padding: 18px 120px 18px 32px;
  }
`;
